module.exports = __webpack_public_path__ + "static/media/Banner_8.59037aac.jpg";